import { Controller } from "stimulus";
import { refreshSticky } from "../mixins/sticky_refresh";

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => refreshSticky());
  }
}
